import React, { memo, useState } from "react";
import { Person, Phone } from "@mui/icons-material";
import { TextField } from "@mui/material";
import { carColor } from "../common/bookingUtils";
import { Booking } from "../../../models/booking";
import "../../../../styles/commonStyle.css"
import { updateBookingField } from '../../../services/BookingService';
import CustomHeader from "../common/CustomHeader"

interface BookingCommunicationDetailsProps {
  booking: Booking;
}

const BookingCommunicationDetails: React.FC<BookingCommunicationDetailsProps> = ({ booking }) => {
  const [name, setName] = useState(booking.name);
  const [phone, setPhone] = useState(booking.phone);

  const [modalOpen, setModalOpen] = useState(false);
  const [nameInput, setNameInput] = useState(booking.name);
  const [phoneInput, setPhoneInput] = useState(booking.phone);

  const handleUpdate = async () => {
    if (nameInput !== name) {
      await updateBookingField(booking._id, "name", nameInput);
      setName(nameInput);
    }
    if (phoneInput !== phone) {
      await updateBookingField(booking._id, "phone", phoneInput);
      setPhone(phoneInput);
    }
    setModalOpen(false);
  };

  return (
    <>
      <div className="bg-white border rounded shadow-sm p-4 text-start" style={{ fontFamily: "Segoe UI, sans-serif", }}>
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <div className="fw-bold" style={{ fontSize: "1.1rem", color: "#2c3e50" }}>
              Passenger Information
            </div>
            <button
              type="button"
              className="btn btn-outline-success btn-sm"
              onClick={() => setModalOpen(true)}
            >
              Modify
          </button>
          </div>

          <small className="customTextXs" style={{ color: '#6c757d', display: 'block', }}>
            The contact information below will be used for all future communications.
         </small>
        </div>

        <div className="d-flex align-items-center mb-3" style={{ color: "#495057" }}>
          <Person fontSize="small" style={{ color: "#28a745", marginRight: "0.75rem" }} />
          <div>
            <div className="customTextXs fw-bold"> Name </div>
            <div>{name}</div>
          </div>
        </div>

        <div className="d-flex align-items-center" style={{ color: "#495057" }}>
          <Phone fontSize="small" style={{ color: "#dc3545", marginRight: "0.75rem" }} />
          <div>
            <div className="customTextXs fw-bold">Phone Number</div>
            <div>{phone}</div>
          </div>
        </div>
      </div>


      {modalOpen && (
        <div className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <CustomHeader value={"Update Passenger Info"}></CustomHeader>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>


              <div className="modal-body">
                <div className="mb-4">
                  <TextField
                    label="Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={nameInput}
                    onChange={(e) => setNameInput(e.target.value)}
                  />
                </div>

                <div className="mb-4">
                  <TextField
                    label="Phone Number"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={phoneInput}
                    onChange={(e) => setPhoneInput(e.target.value)}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <div className="d-flex justify-content-end w-100 gap-2">
                  <button
                    type="button"
                    className="btn back-button w-50"
                    onClick={() => setModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn primary-button w-50"
                    onClick={handleUpdate}
                  >
                    Update
                  </button>
                </div>
              </div>



            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(BookingCommunicationDetails);